import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'pro-public-invoice-redirect',
    template: ` <div></div> `,
})
export class PublicInvoiceRedirectComponent {
    route = inject(ActivatedRoute);

    writeMode: boolean;

    constructor() {
        this.writeMode = this.route.snapshot.data['writeMode'];
        if (this.writeMode) window.location.href = '/pos/public/write-invoice';
        else window.location.href = '/pos/public/get-invoice';
    }
}
